module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('section', [_c('span', [_vm._v("Generation: " + _vm._s(_vm.generationCount))]), _vm._v(" "), _c('span', [_vm._v("Current Population: " + _vm._s(_vm.populationCount))])]), _vm._v(" "), _c('section', [(_vm.islifePaused) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.start()
      }
    }
  }, [_vm._v("Start")]) : _vm._e(), _vm._v(" "), (_vm.islifeInProgress) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.stop()
      }
    }
  }, [_vm._v("Pause")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.randomize()
      }
    }
  }, [_vm._v("Randomize")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.populationCount === 0
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Reset Universe")])]), _vm._v(" "), _c('section', [_c('span', [_vm._v("Interval: " + _vm._s(_vm.interval) + "ms")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interval),
      expression: "interval"
    }],
    attrs: {
      "type": "range",
      "min": "50",
      "max": "1500",
      "step": "50"
    },
    domProps: {
      "value": (_vm.interval)
    },
    on: {
      "__r": function($event) {
        _vm.interval = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('section', [_c('button', {
    attrs: {
      "disabled": _vm.islifeInProgress
    },
    on: {
      "click": function($event) {
        _vm.stepForward()
      }
    }
  }, [_vm._v("Step Forward")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.islifeInProgress || !_vm.hasHistory
    },
    on: {
      "click": function($event) {
        _vm.stepBackward()
      }
    }
  }, [_vm._v("Step Backward")]), _vm._v(" "), _c('span', [_vm._v("History: from " + _vm._s(_vm.firstGenerationInHistory) + " to " + _vm._s(_vm.generationCount))])]), _vm._v(" "), _c('section', [_c('button', {
    attrs: {
      "disabled": _vm.islifeInProgress
    },
    on: {
      "click": function($event) {
        _vm.saveSnapshot()
      }
    }
  }, [_vm._v("Save Snapshot")]), _vm._v(" "), _c('ul', {
    staticClass: "snapshots"
  }, _vm._l((_vm.snapshots), function(snapshot, index) {
    return _c('li', [_c('button', {
      staticClass: "restore",
      attrs: {
        "disabled": _vm.islifeInProgress,
        "title": 'Restore Snapshot (' + snapshot.created + ')'
      },
      on: {
        "click": function($event) {
          _vm.restoreSnapshot(snapshot)
        }
      }
    }, [_vm._v("\n          Restore (" + _vm._s(snapshot.totalCells) + " cells)\n        ")]), _vm._v(" "), _c('button', {
      staticClass: "delete",
      attrs: {
        "disabled": _vm.islifeInProgress,
        "title": "Delete Snapshot"
      },
      on: {
        "click": function($event) {
          _vm.deleteSnapshot(index)
        }
      }
    }, [_vm._v("\n          x\n        ")])])
  }))]), _vm._v(" "), _c('section', [_c('span', [_vm._v("Add pattern:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPattern),
      expression: "selectedPattern"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPattern = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.patterns), function(pattern) {
    return _c('option', {
      domProps: {
        "value": pattern
      }
    }, [_vm._v("\n        " + _vm._s(pattern.name) + " (" + _vm._s(pattern.cells.length) + ")\n      ")])
  })), _vm._v(" "), (_vm.selectedPattern) ? _c('div', {
    staticClass: "drag-item",
    class: {
      'dragged': _vm.isPatternDragged
    },
    attrs: {
      "draggable": "true"
    },
    on: {
      "dragstart": _vm.dragstart,
      "dragend": _vm.dragend
    }
  }, [_vm._v("\n      Drag Me →\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44b6465e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Control.vue
// module id = 102
// module chunks = 1